module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "epa-coal-mines--cover.fb469773.jpg";